import React from "react";
import {Link} from "react-router-dom";
import UpsellingIcon from '../../../assets/upselling.png';
import UpsellingIconNoUpselling from '../../../assets/no-upselling.png';

const CompanyUpsellingBadge = ({
                                   portal, showUpselling, companyID, hasUpselling, dataUpselling,
                               }) => (<>
        {portal === 'dgg' && showUpselling && (<div className="flex flex-row items-center gap-4 text-xs h-5 mt-2">
                <Link
                    className="py-2 ps-5 flex items-center text-2xl"
                    to={`/dienstleistungen/dgg/${companyID}`}
                    target="_blank"
                    title={hasUpselling ? "Upselling" : "Upselling inaktiv"}
                >
                    <img
                        src={hasUpselling ? UpsellingIcon : UpsellingIconNoUpselling}
                        alt={hasUpselling ? "Upselling" : "Upselling inaktiv"}
                        className="w-6 h-6"
                    />
                </Link>
                {hasUpselling && <div
                    className={`h-7 border border-1 border-whiteDarker rounded shadow flex flex-row items-center gap-4 text-xs -ms-2 p-1`}>
                    {Object.entries(dataUpselling)
                        .filter(([key, val]) => {
                            if (key === 'FP_ID') return false;
                            if (!val || val === 'Keine Information') return false;
                            if (typeof val === 'string' && val.indexOf('--') !== -1) return false;
                            return true;
                        })
                        .map(([key, val]) => {
                            // Safely convert to string
                            const valStr = typeof val === 'string' ? val : String(val);
                            const displayText = valStr.includes(',') ? valStr.split(',')[0] : valStr;

                            // Special handling for Prozess field - display text only without icon
                            if (key === 'Prozess') {
                                return (<div key={key} className="flex items-center gap-2 text-xs">
                                        <span className="font-semibold">{displayText}</span>
                                    </div>);
                            }

                            // For other fields, show icon as before
                            const imageSrc = `${window.location.origin}/icons/${displayText.replace(/\s/g, '')}.png`;
                            return (<div key={key} className="flex items-center gap-2 text-xs">
                                    <img
                                        src={imageSrc}
                                        className="w-5 h-5"
                                        alt={key}
                                    />
                                    <span>{key}</span>
                                </div>);
                        })}
                </div>}
                {!hasUpselling && <span className={`text-sm border border-1 border-whiteDarker p-1 rounded shadow`}>Upselling inaktiv</span>}
            </div>)}
    </>);

export default CompanyUpsellingBadge;

